import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Renders a set of internal-link cards (e.g. related planning pages or guides).
export const RelatedLinks = ({ title = "Keep planning", links = [], testId = "related-links" }) => {
  if (!links.length) return null;
  return (
    <div data-testid={testId}>
      <h3 className="font-serif text-xl font-medium text-charcoal">{title}</h3>
      <ul className="mt-4 space-y-2.5">
        {links.map((link, i) => (
          <li key={i}>
            <Link
              to={link.to}
              className="group flex items-center justify-between gap-3 rounded-xl border border-stone-line bg-white px-5 py-3.5 text-charcoal transition-all hover:border-gold hover:shadow-soft"
            >
              <span className="font-medium">{link.label}</span>
              <ArrowUpRight
                size={17}
                className="text-slatey transition-all group-hover:text-gold group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RelatedLinks;
